/**
 * 铁路出口相关常量
 */
import CommonState from './CommonState'

// ------------
// 运输类型
// ------------
export const LINE_TRANSPORT = new CommonState('LINE_TRANSPORT', '班列运输', 'Line Transport')
export const DOMESTIC_TRANSPORT = new CommonState('DOMESTIC_TRANSPORT', '国内运输', 'Domestic Transport')
export const FULL_TRANSPORT = new CommonState('FULL_TRANSPORT', '国联全程', 'Full Transport')
export const HALF_TRANSPORT = new CommonState('HALF_TRANSPORT', '国联半程', 'Half Transport')
export const FULL_TRANSIT = new CommonState('FULL_TRANSIT', '过境全程', 'Full Transit')
export const HALF_TRANSIT = new CommonState('HALF_TRANSIT', '过境半程', 'Half Transit')
export const SEARAIL_TRANSPORT = new CommonState('SEARAIL_TRANSPORT', '海铁联运', 'Sea Rail Transport')
export const RAILWAY_TRANSPORT = new CommonState('RAILWAY_TRANSPORT', '铁路联运', 'Railway Transport')

export const TRANSPORTTYPE_TYPES = [LINE_TRANSPORT, DOMESTIC_TRANSPORT, FULL_TRANSPORT, HALF_TRANSPORT, FULL_TRANSIT, HALF_TRANSIT, SEARAIL_TRANSPORT, RAILWAY_TRANSPORT]

// ------------
// 全程/半程
// ------------
export const FULL_COURSE = new CommonState('FULL_COURSE', '全程', 'Full Course')
export const HALF_COURSE = new CommonState('HALF_COURSE', '半程', 'Half Course')

export const FULLHALF_TYPES = [FULL_COURSE, HALF_COURSE]

/**
 * 箱型
 */

export const BOX_TYPE_20 = new CommonState('20', "20'", "20'")
export const BOX_TYPE_40 = new CommonState('40', "40'", "40'")
export const BOX_TYPE_45 = new CommonState('45', "45'", "45'")
export const BOX_TYPE_10 = new CommonState('10', "10'", "10'")
export const BOX_TYPE_50 = new CommonState('50', "50'", "50'")
export const BOX_TYPE_53 = new CommonState('53', "53'", "53'")
export const BOX_TYPE_30 = new CommonState('30', "30'", "30'")
export const BOX_TYPE_48 = new CommonState('48', "48'", "48'")
export const BOX_TYPE_60 = new CommonState('60', "60'", "60'")
export const BOX_TYPE_70 = new CommonState('70', "70'", "70'")

/**
 * 铁路取值
 */
export const RAILWAY_EXPORT_BOX_TYPES = [
  BOX_TYPE_20,
  BOX_TYPE_40,
  BOX_TYPE_45,
  BOX_TYPE_10,
  BOX_TYPE_50,
  BOX_TYPE_53,
  BOX_TYPE_30,
  BOX_TYPE_48,
  BOX_TYPE_60,
  BOX_TYPE_70
]
